/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import { useEffect, useRef, useState } from "react"
import { Link } from "react-router"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const closeMenu = () => {
    setIsMenuOpen(false)
  }

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: Event) => {
      const target = event.target as Element
      const header = dropdownRef.current

      if (isMenuOpen && header && !header.contains(target)) {
        setIsMenuOpen(false)
      }
    }

    // Only add listener when menu is open
    if (isMenuOpen) {
      // Use capture phase to catch events before they bubble
      document.addEventListener("click", handleClickOutside, { capture: true })
    }

    return () => {
      document.removeEventListener("click", handleClickOutside, { capture: true })
    }
  }, [isMenuOpen])

  return (
    <header
      className="pt-3 pb-2 px-2 px-sm-4 px-md-4 pt-md-3 pt-lg-4 my-lg-1 px-lg-5"
      ref={dropdownRef}
    >
      <nav className="navbar navbar-expand-lg">
        {/* Remove container-fluid wrapper */}
        {/* Brand - left-aligned on all screens */}
        <Link to="/" className="navbar-brand">
          <h1 className="fs-2 m-0">Safe Retirement Spending</h1>
        </Link>

        {/* Hamburger button - only visible on small screens, positioned on the right */}
        <button
          className="navbar-toggler d-lg-none ms-auto"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isMenuOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navigation links - horizontal on desktop, dropdown on mobile */}
        <div className={`navbar-collapse ${isMenuOpen ? "show" : ""} d-lg-flex`} id="navbarNav">
          <div className="navbar-nav ms-auto">
            <Link
              className="nav-link text-decoration-none me-lg-3"
              to="/about/"
              onClick={closeMenu}
            >
              About
            </Link>
            <Link
              className="nav-link text-decoration-none me-lg-3"
              to="/guide/"
              onClick={closeMenu}
            >
              Guide
            </Link>
            <Link
              className="nav-link text-decoration-none me-lg-3"
              to="/methodology/"
              onClick={closeMenu}
            >
              Methodology
            </Link>
            <Link className="nav-link text-decoration-none" to="/contact/" onClick={closeMenu}>
              Contact
            </Link>
          </div>
        </div>
      </nav>
    </header>
  )
}

export default Header
